import DialogComponent from "components/Dialog";

import ContentBlock from "components/ContentBlock";
import Button from "components/Button";
import ButtonIcon from "components/ButtonIcon";

import { ReactComponent as UploadIcon } from 'icons/components/upload.svg';
import { ReactComponent as NotificationInfoIcon } from 'icons/components/notificationInfo.svg';

import './index.less';
import './themes/default.less';

export default class FileUploadDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.showComment = true;

        this.defaultState = {
            ...this.state,
            selectedImage: null,
            selectedFile: null,
            info: null,
            oldFile: true,
            comment: "",
        };

        this.state = { ...this.defaultState };
    }

    title = "client.uploadFile";

    show(info, hideCb) {
        this.dialogTitle = info.title ? info.title : "client.uploadFile";
        this.header = info.header ? info.header : null;
        this.accept = info.accept ? info.accept : null;
        const selectedImage = info.path ? info.path : null;
        const selectedFile = info.path ? info.name : null;
        const comment = (info.comment || "");
        this.pathBig = info.pathBig ? info.pathBig : null;
        this.id = info.id ? info.id : null;
        const oldFile = !!selectedImage;
        this.hidCb = hideCb;

        this.setState({ selectedImage, selectedFile, info, oldFile, comment });

        super.show();
    }

    async save() {
        const { selectedFile } = this.state;

        if (selectedFile) {
            this._helper.showLoading();

            const infoFile = {
                fileInfo: { file: selectedFile, name: selectedFile.name },
                type: "SNAPSHOT",
                comment: this.inpComm.value,
                ...this.state.info.infoFile
            };

            //let resp = "";
            if (this.id) {
                if (infoFile.fileInfo.name)
                    await this._request.files.replace(this.id, infoFile);
                else
                    await this._request.fileStorage.update(this.id, { comment: infoFile.comment });
            } else
                await this._request.files.upload(infoFile);

            //const resp = this.id ? await this._request.files.replace(this.id, infoFile) : await this._request.files.upload(infoFile);

            this._helper.hideLoading();

            //if (resp?.data) {
            this.hide();

            if (this.hidCb?.apply)
                this.hidCb();
            //}
        }

    }

    fileChange = (event) => {
        const selectedFile = event.target.files[0];
        this.state.oldFile = false;
        if (selectedFile && (selectedFile.type === 'image/jpeg' || selectedFile.type === 'image/png')) {
            const selectedImage = URL.createObjectURL(selectedFile);
            this.setState({ selectedFile, selectedImage });
        } else if (selectedFile && selectedFile.type === 'text/csv') {
            this.changeState("selectedFile", selectedFile);
        } else {
            //this.changeState("selectedImage", null);
            //this.changeState("selectedFile", null);
            const selectedImage = null;
            this.setState({ selectedFile, selectedImage });
        }
    };

    onHandleDrop(e) {
        this._helper.stopEvent(e);
        this.state.oldFile = false;
        const selectedFile = e.dataTransfer.files[0];
        if (selectedFile && (selectedFile.type === 'image/jpeg' || selectedFile.type === 'image/png')) {
            const selectedImage = URL.createObjectURL(selectedFile);
            this.setState({ selectedFile, selectedImage });
        } else if (selectedFile && (selectedFile.type === '.csv')) {
            this.changeState("selectedFile", selectedFile);
        } else {
            const selectedImage = null;
            this.setState({ selectedFile, selectedImage });
        }
    }

    onHandleDragOver(e) {
        this._helper.stopEvent(e);
    }

    clickSelectFile() {
        this.fileInputRef.click();
    }

    deleteFile() {
        const selectedImage = null;
        const selectedFile = null;
        this.setState({ selectedFile, selectedImage });
    }

    async downloadImg() {
        const { selectedFile } = this.state;
        await this._request.images.downloadImg(this.pathBig, selectedFile);
    }

    renderHeader() {
        return (<div className="warning flex gap8 rad8">
            <div><NotificationInfoIcon /></div>
            <div className="flex col gap4">
                <div className="text p1SemiBold">{this.tr("price.doPriceTemplate")}</div>
                <div className="textw text p1">{this.tr("price.warning")}</div>
                <div className="link text p1 hand">{this.tr("price.downloadCSVTemplate")}</div>
            </div>
        </div>);
    }

    renderFormUploadFile() {
        return (<div className="flex col gap16">
            <ContentBlock border="dashed">
                <div
                    className="fileUplCont flex col gap16 centerV"
                    onDrop={this.onHandleDrop.bind(this)}
                    onDragOver={this.onHandleDragOver.bind(this)}
                    onClick={this.clickSelectFile.bind(this)}
                >
                    <UploadIcon />
                    <div className="fileUplText text p1">
                        {this.tr("client.dragMess")}
                    </div>
                    <div className="fileUplButton">
                        <Button
                            label="client.selectFile"
                            size="small"
                        />
                    </div>
                </div>
            </ContentBlock>
        </div>);
    }

    renderUploadedFile() {
        const { selectedImage, selectedFile, oldFile } = this.state;

        return (<div className="flex col gap16">
            <div className="selCont flex">
                {selectedImage ? <div className="imgCont">
                    <img
                        src={selectedImage}
                        alt="Selected"
                        style={{ width: '120px', height: '120px', objectFit: 'cover' }}
                    />
                </div> : <div className="flex col gap4 text p2">
                    <div>{selectedFile.name}</div>
                    <div className="fileUplText">
                        {this._helper.string.formatFileSize(selectedFile.size)}
                    </div>
                </div>}
                <div className="buttonsCont flex flex1 end">
                    <div className="flex gap16">
                        <Button
                            type={"secondary"}
                            size={"small"}
                            label={"client.replace"}
                            onClick={this.clickSelectFile.bind(this)}
                        />
                        {oldFile && <ButtonIcon
                            name="download"
                            tooltip="client.downloadFile"
                            onClick={this.downloadImg.bind(this)}
                        />}
                        <ButtonIcon
                            name="trash"
                            tooltip="client.deleteFile"
                            onClick={this.deleteFile.bind(this)}
                        />
                    </div>
                </div>
            </div>

        </div>);
    }

    renderContent() {
        const { selectedFile, comment } = this.state;
        return (
            <div className="fileUploadDialog content flex col gap16">
                {this.header && this.renderHeader()}
                {selectedFile ? this.renderUploadedFile() : this.renderFormUploadFile()}
                {this.showComment && this.insertInput({
                    ref: el => this.inpComm = el,
                    label: "main.comment",
                    placeHolder: "main.freeComment",
                    value: comment,
                    readonly: selectedFile ? false : true
                })}
                <input
                    className="fileUplInput"
                    type="file"
                    ref={el => this.fileInputRef = el}
                    style={{ display: 'none' }}
                    accept={this.accept}
                    onChange={this.fileChange.bind(this)}
                />
            </div>
        );
    }

}

